'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _stageHeaders = require('./stage-headers');

var _stageHeaders2 = _interopRequireDefault(_stageHeaders);

var _judgesReports = require('./judges-reports');

var _judgesReports2 = _interopRequireDefault(_judgesReports);

var _productsByAccount = require('./products-by-account');

var _productsByAccount2 = _interopRequireDefault(_productsByAccount);

var _quantityByProduct = require('./quantity-by-product');

var _quantityByProduct2 = _interopRequireDefault(_quantityByProduct);

var _balanceDueReport = require('./balance-due-report');

var _balanceDueReport2 = _interopRequireDefault(_balanceDueReport);

var _dressReport = require('./dress-report');

var _dressReport2 = _interopRequireDefault(_dressReport);

var _competitorsBySchool = require('./competitors-by-school');

var _competitorsBySchool2 = _interopRequireDefault(_competitorsBySchool);

var _competitorCompetition = require('./competitor-competition');

var _competitorCompetition2 = _interopRequireDefault(_competitorCompetition);

var _awardsCountByEventLevel = require('./awards-count-by-event-level');

var _awardsCountByEventLevel2 = _interopRequireDefault(_awardsCountByEventLevel);

var _awardsForecaster = require('./awards-forecaster');

var _awardsForecaster2 = _interopRequireDefault(_awardsForecaster);

var _collectedAwards = require('./collected-awards');

var _collectedAwards2 = _interopRequireDefault(_collectedAwards);

var _events = require('../../../../../events');

var _events2 = _interopRequireDefault(_events);

var _reportsCsv = require('../../../../../reports-csv');

var _reportsCsv2 = _interopRequireDefault(_reportsCsv);

var _ifeisIsomorphic = require('ifeis-isomorphic');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReportsController = function () {
  function ReportsController(feis, fStages, $q, $state, fEventService, fFeisService, fCSVReportsService, fRegistrationService, stageActions, $mdDialog) {
    var _this = this;

    _classCallCheck(this, ReportsController);

    this._ = {
      fStages: fStages,
      $q: $q,
      $state: $state,
      fFeisService: fFeisService,
      fCSVReportsService: fCSVReportsService,
      $mdDialog: $mdDialog
    };
    this._stages = fStages.for(feis.id);
    this._events = fEventService.for(feis.id);
    this._reg = fRegistrationService.for(feis.id);
    this._feis = fFeisService;
    this.feis = feis;
    this.feis.$$days = stageActions.prepareFeisDays(this.feis, this.feis.tz);
    this.isLoading = false;

    this.reports = [{
      title: 'Balance Due Report:  List of account owners and dancers with balance due',
      href: $state.href('feiseanna.one.admin.reports.balance-due-report')
    }, {
      title: 'Product by Account: Purchased items by account with balance due',
      href: $state.href('feiseanna.one.admin.reports.products-by-account')
    }, {
      title: 'Quantity by Product: Summary of purchased items',
      href: $state.href('feiseanna.one.admin.reports.quantity-by-product')
    }, {
      title: 'Competitor List by School: Report of registrations with Balance Due by school',
      href: $state.href('feiseanna.one.admin.reports.competitors-by-school-report')
    }, {
      title: 'Competitor/Competition Report: List of competitors with their competition details',
      href: $state.href('feiseanna.one.admin.reports.competitor-competition-report')
    }, {
      title: 'Judges Report: Raw scores and placings calculations for PC/OC by competition or by judge',
      href: $state.href('feiseanna.one.admin.reports.judges-reports')
    }, {
      title: 'Dress Report: List of dancers who received a wardrobe comment with teacher contacts',
      href: $state.href('feiseanna.one.admin.reports.dress-report')
    }, {
      title: 'Collected Awards:  List of awards collected by competitor',
      href: $state.href('feiseanna.one.admin.reports.collected-awards-report')
    }, {
      title: 'Actual Awards Counts',
      href: $state.href('feiseanna.one.admin.reports.awards-count-by-event-level')
    }];

    this.downloads = [{
      title: 'Competition Labels: Competition number, name, etc. in stage schedule order',
      fn: function fn() {
        return _this.generateCompetitionLabelsCSV();
      }
    }, {
      title: 'Competitor Labels: Competitor name, school in alpha last name, first name order',
      fn: function fn() {
        return _this.generateCompetitorLabelsCSV();
      }
    }, {
      title: 'Paid Participants: Download of competitors with competitions, and school',
      fn: function fn() {
        return _this.generateParticipantsCSV();
      }
    }];
  }

  _createClass(ReportsController, [{
    key: 'generateCompetitionLabelsCSV',
    value: function generateCompetitionLabelsCSV() {
      var _this2 = this;

      this.isLoading = true;
      var stages = void 0;
      var events = void 0;

      this._.$q.all([this._stages.all(), this._events.all()]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            s = _ref2[0],
            e = _ref2[1];

        stages = s.map(function (s) {
          return _this2._stages.withStage(s.id, s);
        });
        events = e.reduce(function (o, e) {
          o[e.id] = e;return o;
        }, {});
        return _this2._.$q.all(stages.map(function (s) {
          return s.schedule(true);
        }));
      }).then(function (s) {
        stages.forEach(function (stage, idx) {
          stage.$schedule = s[idx].filter(function (e) {
            return !e.placeholder;
          });
          stage.date = (0, _moment2.default)(stage._stage.dt).tz(_this2.feis.tz).format('MM/DD/YYYY');
        });
        // sort by time and name
        var sortedStages = stages.sort(function (a, b) {
          var aCat = a._stage.dt + a._stage.name;
          var bCat = b._stage.dt + b._stage.name;
          return aCat.localeCompare(bCat);
        });
        return sortedStages;
      }).then(function (stages) {
        var reportData = stages.flatMap(function (stage) {
          return stage.$schedule.map(function (e) {
            var event = events[e.id];
            return {
              "Stage Name": stage._stage.name || "n/a",
              "Competition Name": event.name || "n/a",
              "Competition Age": event.age || "n/a",
              "Level": event.level || "n/a",
              "Event Type": event.event || "n/a",
              "Date": stage.date || "n/a"
            };
          });
        });
        return _this2._.fCSVReportsService.prepareCSV(reportData, _this2.feis.slug + '_competition-labels.csv');
      }).finally(function () {
        _this2.isLoading = false;
      });
    }
  }, {
    key: 'generateCompetitorLabelsCSV',
    value: function generateCompetitorLabelsCSV() {
      var _this3 = this;

      this.isLoading = true;
      this._feis.competitors(this.feis.id, { disable_limit: true }).then(function (participants) {
        var report = participants.map(function (p) {
          return {
            "Last Name": p.lname || 'n/a',
            "First Name": p.fname || 'n/a',
            "Competitor #": p.competitor || 'n/a',
            "School": p.school && p.school.name ? p.school.name : 'n/a'
          };
        });
        // sort by last, first name
        report.sort(function (a, b) {
          var lastNameA = a['Last Name'].toLowerCase();
          var lastNameB = b['Last Name'].toLowerCase();

          if (lastNameA < lastNameB) return -1;
          if (lastNameA > lastNameB) return 1;

          var firstNameA = a['First Name'].toLowerCase();
          var firstNameB = b['First Name'].toLowerCase();

          if (firstNameA < firstNameB) return -1;
          if (firstNameA > firstNameB) return 1;

          return 0;
        });

        return _this3._.fCSVReportsService.prepareCSV(report, _this3.feis.slug + '_competitor-labels.csv');
      }).finally(function () {
        _this3.isLoading = false;
      });
    }
  }, {
    key: 'generateParticipantsCSV',
    value: function generateParticipantsCSV() {
      var _this4 = this;

      this.isLoading = true;
      this._.$q.all([this._reg.all({ paid: true }), this._feis.accounts(this.feis.id)]).then(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            participants = _ref4[0],
            accounts = _ref4[1];

        var report = participants.map(function (p) {
          return {
            "Competitor": p.competitor || 0,
            "First Name": p.fname || 'n/a',
            "Last Name": p.lname || 'n/a',
            "Email": accounts.find(function (account) {
              return account.id === p.account_id;
            }).email || 'n/a', // get email from account list
            "School": p.school && p.school.name ? p.school.name : 'n/a',
            "Events": p.registrations ? p.registrations.map(function (e) {
              return e.event.name;
            }).join(', ') : 'n/a'
          };
        });
        // sort by last, first name
        report.sort(function (a, b) {
          var lastNameA = a['Last Name'].toLowerCase();
          var lastNameB = b['Last Name'].toLowerCase();

          if (lastNameA < lastNameB) return -1;
          if (lastNameA > lastNameB) return 1;

          var firstNameA = a['First Name'].toLowerCase();
          var firstNameB = b['First Name'].toLowerCase();

          if (firstNameA < firstNameB) return -1;
          if (firstNameA > firstNameB) return 1;

          return 0;
        });

        return _this4._.fCSVReportsService.prepareCSV(report, _this4.feis.slug + '_participants.csv');
      }).finally(function () {
        _this4.isLoading = false;
      });
    }
  }]);

  return ReportsController;
}();

// update modules


exports.default = angular.module('ifeis.routes.feiseanna.one.admin.reports', ['ifeis.events', 'ifeis.printing', 'ifeis.csv', 'ifeis.routes.feiseanna.one.admin.reports.stage-headers', 'ifeis.routes.feiseanna.one.admin.schools', 'ifeis.routes.feiseanna.one.admin.reports.judges-reports', 'ifeis.routes.feiseanna.one.admin.reports.products-by-account', 'ifeis.routes.feiseanna.one.admin.reports.quantity-by-product', 'ifeis.routes.feiseanna.one.admin.reports.balance-due-report', 'ifeis.routes.feiseanna.one.admin.reports.dress-report', 'ifeis.routes.feiseanna.one.admin.reports.competitors-by-school-report', 'ifeis.routes.feiseanna.one.admin.reports.competitor-competition-report', 'ifeis.routes.feiseanna.one.admin.reports.collected-awards-report', 'ifeis.routes.feiseanna.one.admin.reports.awards-count-by-event-level', 'ifeis.router-history', 'ifeis.printing.compcards', 'ifeis.printing.parentcards']).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.admin.reports', {
    url: '/reports',
    template: require('./tpl.html'),
    controller: ReportsController,
    controllerAs: 'reports',
    ncyBreadcrumb: {
      label: 'Reports & Downloads',
      parent: 'feiseanna.one.admin.manager'
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/reports/index.js
// module id = 563
// module chunks = 0